module.exports = __webpack_public_path__ + "static/exercise-img-3-8e94ffa87d21b01acced9aafedfc8dd9.png";